import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let LikeButton = class LikeButton extends Vue {
    constructor() {
        super(...arguments);
        this.backgroundColor = "#feca38";
        this.textColor = "#000";
        this.svgTransform = "";
    }
    get backgroundRules() {
        return `background-color: ${this.backgroundColor};`;
    }
    get colorRules() {
        if (this.selected) {
            return `fill:${this.textColor}`;
        }
        return "fill:#B3B6B8";
    }
    created() {
        const colors = this.$store.getters.colors;
        this.backgroundColor = colors.backgroundColor;
        this.textColor = colors.textColor;
    }
    mounted() {
        const circle = this.$refs.circle;
        const originalHeight = 274;
        // const originalWidth = 292 
        const scale = (circle.clientHeight * 0.75) / (originalHeight);
        const x = -(circle.clientWidth / 2) * .50;
        const y = -(circle.clientHeight / 2) * .40;
        this.svgTransform = `translate(${x},${y}) scale(${scale})`;
    }
};
__decorate([
    Prop({ default: true })
], LikeButton.prototype, "positive", void 0);
__decorate([
    Prop({ default: false })
], LikeButton.prototype, "selected", void 0);
LikeButton = __decorate([
    Component
], LikeButton);
export default LikeButton;
